<template>
    <v-app style="background:#f4f7fb;">
        <v-app-bar app dense color="#0D2D5E" dark elevation="1" height="80">
            <v-icon size="30" color="#7E8DA1" class="ml-5 mr-2">mdi-chart-bar</v-icon>
            <div class="fs-bar-text">
                <div class="fs-bar-title">The First Steps</div>
                <div class="fs-bar-sub ml-5 mt-2">by My Farewell Wishes</div>
            </div>
        </v-app-bar>
        <v-main style="padding:0px!important;">
            <slot />
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'FirstStepsAuthLayout',
}
</script>

<style scoped>
.fs-bar-text {
    display: flex;
    justify-content: center;
    line-height: 1.15;
}

.fs-bar-title {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
}

.fs-bar-sub {
    font-size: 12px;
    color: #8493A8;
}
</style>
